import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import LandingPage from "@/pages/Landing";
import LoginPage, { RegisterPage } from "@/pages/Auth";
import PricingPage from "@/pages/Pricing";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import DashboardPage from "@/pages/Dashboard";
import NewAuditPage from "@/pages/NewAudit";
import AuditDetailPage from "@/pages/AuditDetail";
import BillingPage from "@/pages/Billing";
import AdminSettingsPage from "@/pages/AdminSettings";
import AdminUsersPage from "@/pages/AdminUsers";
import WorkspacePage from "@/pages/Workspace";
import InvitePage from "@/pages/InvitePage";
import ComparePage from "@/pages/Compare";

function Protected({ children }) {
  const { user, booting } = useAuth();
  if (booting) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-muted">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, booting } = useAuth();
  if (booting) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/app/dashboard" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, booting } = useAuth();
  if (booting) return null;
  if (user) return <Navigate to="/app/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
          <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/app/dashboard" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/app/history" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/app/new" element={<Protected><NewAuditPage /></Protected>} />
          <Route path="/app/audit/:id" element={<Protected><AuditDetailPage /></Protected>} />
          <Route path="/invite" element={<InvitePage />} />
          <Route path="/app/billing" element={<Protected><BillingPage /></Protected>} />
          <Route path="/app/compare" element={<Protected><ComparePage /></Protected>} />
          <Route path="/app/workspace" element={<Protected><WorkspacePage /></Protected>} />
          <Route path="/app/admin" element={<AdminOnly><AdminSettingsPage /></AdminOnly>} />
          <Route path="/app/admin/users" element={<AdminOnly><AdminUsersPage /></AdminOnly>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
